import * as api from '../api/massImportExemptions';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_IMPORT_EXEMPTIONS = createRequestTypes(
  `${prefix}/FETCH_IMPORT_EXEMPTIONS`,
);

export const fetchImportExemptions = makeApiActionCreatorV3(
  api.fetchImportExemptions,
  FETCH_IMPORT_EXEMPTIONS[START],
  FETCH_IMPORT_EXEMPTIONS[SUCCESS],
  FETCH_IMPORT_EXEMPTIONS[ERROR],
);

export const FETCH_IMPORT_EXEMPTION = createRequestTypes(
  `${prefix}/FETCH_IMPORT_EXEMPTION`,
);

export const fetchImportExemption = makeApiActionCreatorV3(
  api.fetchImportExemption,
  FETCH_IMPORT_EXEMPTION[START],
  FETCH_IMPORT_EXEMPTION[SUCCESS],
  FETCH_IMPORT_EXEMPTION[ERROR],
);

export const CREATE_IMPORT_EXEMPTION = createRequestTypes(
  `${prefix}/CREATE_IMPORT_EXEMPTION`,
);

export const createImportExemption = makeApiActionCreatorV3(
  api.createImportExemption,
  CREATE_IMPORT_EXEMPTION[START],
  CREATE_IMPORT_EXEMPTION[SUCCESS],
  CREATE_IMPORT_EXEMPTION[ERROR],
);

export const FETCH_IMPORT_EXEMPTION_YEARS_TO_PROCESS = createRequestTypes(
  `${prefix}/FETCH_IMPORT_EXEMPTION_YEARS_TO_PROCESS`,
);

export const fetchImportExemptionYearstoProcess = makeApiActionCreatorV3(
  api.fetchImportExemptionYearstoProcess,
  FETCH_IMPORT_EXEMPTION_YEARS_TO_PROCESS[START],
  FETCH_IMPORT_EXEMPTION_YEARS_TO_PROCESS[SUCCESS],
  FETCH_IMPORT_EXEMPTION_YEARS_TO_PROCESS[ERROR],
);

export const CREATE_PROCESS_EXEMPTION = createRequestTypes(
  `${prefix}/CREATE_PROCESS_EXEMPTION`,
);

export const createProcessExemption = makeApiActionCreatorV3(
  api.createProcessExemption,
  CREATE_PROCESS_EXEMPTION[START],
  CREATE_PROCESS_EXEMPTION[SUCCESS],
  CREATE_PROCESS_EXEMPTION[ERROR],
);

export const FETCH_IMPORT_EXEMPTION_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_IMPORT_EXEMPTION_PROPERTIES`,
);

export const fetchImportExemptionProperties = makeApiActionCreatorV3(
  api.fetchImportExemptionProperties,
  FETCH_IMPORT_EXEMPTION_PROPERTIES[START],
  FETCH_IMPORT_EXEMPTION_PROPERTIES[SUCCESS],
  FETCH_IMPORT_EXEMPTION_PROPERTIES[ERROR],
);

export const FETCH_AVAILABLE_STATE_CODES = createRequestTypes(
  `${prefix}/FETCH_AVAILABLE_STATE_CODES`,
);

export const fetchAvailableStateCodes = makeApiActionCreatorV3(
  api.fetchAvailableStateCodes,
  FETCH_AVAILABLE_STATE_CODES[START],
  FETCH_AVAILABLE_STATE_CODES[SUCCESS],
  FETCH_AVAILABLE_STATE_CODES[ERROR],
);

export const FETCH_HS_STATE_CODES = createRequestTypes(
  `${prefix}/FETCH_HS_STATE_CODES`,
);

export const fetchHSStateCodes = makeApiActionCreatorV3(
  api.fetchHSStateCodes,
  FETCH_HS_STATE_CODES[START],
  FETCH_HS_STATE_CODES[SUCCESS],
  FETCH_HS_STATE_CODES[ERROR],
);

export const INSERT_HS_STATE_CODE = createRequestTypes(
  `${prefix}/INSERT_HS_STATE_CODE`,
);

export const insertHSStateCode = makeApiActionCreatorV3(
  api.insertHSStateCode,
  INSERT_HS_STATE_CODE[START],
  INSERT_HS_STATE_CODE[SUCCESS],
  INSERT_HS_STATE_CODE[ERROR],
);

export const DELETE_HS_STATE_CODE = createRequestTypes(
  `${prefix}/DELETE_HS_STATE_CODE`,
);

export const deleteHSStateCode = makeApiActionCreatorV3(
  api.deleteHSStateCode,
  DELETE_HS_STATE_CODE[START],
  DELETE_HS_STATE_CODE[SUCCESS],
  DELETE_HS_STATE_CODE[ERROR],
);
